import type { IconSvgObject } from './types';

const Cursor02Icon: IconSvgObject = [
  ["path", { d: "M3.67498 3.03423L20.6821 9.57542C21.1163 9.74242 21.1022 10.3615 20.6609 10.5086L13.2819 12.9683C13.1338 13.0177 13.0176 13.1339 12.9683 13.2819L10.5086 20.6609C10.3615 21.1023 9.74236 21.1163 9.57536 20.6821L3.03417 3.67504C2.87993 3.27402 3.27396 2.87999 3.67498 3.03423Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Cursor02Icon;
